module.exports = __webpack_public_path__ + "static/media/PigeonRTC_signalling.8ef6af10.png";